import React from 'react'
import styled from '@emotion/styled'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { TitledList } from 'src/components/sidebar-panels/titled-list'
import { Typography } from '@mui/material'
import { Colors, Shapes } from 'src/components/theme'
import { googlePlaceId, googleSearchString } from 'src/atoms/search'
import { GooglePlace } from 'src/utils/google-places'
import { useSetGooglePlace } from 'src/hooks/use-select-google-place'

const NotFoundWrapper = styled.div`
  padding: ${Shapes.spacing[1]}px ${Shapes.spacing[4]}px;
  margin-top: 100px;
`

const NotFoundBack = styled.span`
  color: ${Colors.blueDark};
  cursor: pointer;
`

export function useRefreshPlaceId(place: GooglePlace | null | undefined) {
  const placeId = useRecoilValue(googlePlaceId)
  const setGooglePlaceId = useSetGooglePlace()

  React.useEffect(() => {
    if (!place) {
      return
    }
    if (placeId !== place.place_id) {
      setGooglePlaceId(place.place_id)
    }
  }, [place])
}

export const NotFound: React.FC = () => {
  const setSearchString = useSetRecoilState(googleSearchString)

  const onClickBack = () => {
    setSearchString(undefined)
  }

  return (
    <TitledList title="Not Found">
      <NotFoundWrapper>
        <Typography variant="title2m" color={Colors.textDark}>
          Sorry, that location could not be found. Please try again or{' '}
          <NotFoundBack onClick={onClickBack}>go back to your recently viewed locations</NotFoundBack>.
        </Typography>
      </NotFoundWrapper>
    </TitledList>
  )
}
